var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#0077b5",
    height: 512,
    rx: "15%",
    width: 512
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 138,
    r: 37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m244 194v198m-102-198v198",
    stroke: "#fff",
    strokeWidth: 66
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66v-113c0-61-32-89-76-89-34 0-51 19-59 32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f1f401c04912ae5cce867d63f4d0a64e.svg";
export { ForwardRef as ReactComponent };